// extracted by mini-css-extract-plugin
export var loaderContainer = "styles-module--loaderContainer--liM85";
export var loader = "styles-module--loader--3xqLW";
export var spin = "styles-module--spin--enax2";
export var loaderMessage = "styles-module--loaderMessage--2cOkW";